import { TRootState, TBusinessUnitsState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { businessUnitsAdapter } from './adapter'

const selectState = (state: TRootState): TBusinessUnitsState => state.businessUnits

const adapterSelectors = businessUnitsAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

const totalItems = createSelector(
    selectState,
    (state) => (state.totalItems)
)

export const selectors = {
    ...adapterSelectors,
    fetchStatus,
    totalItems,
}